import { Directive, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[validateEqual][ngControl],[validateEqual][ngFormControl],[validateEqual][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidatorDirective), multi: true }
    ]
})
export class EqualValidatorDirective implements Validator {
    @Input('validateEqual') validateEqual: AbstractControl;
    constructor() {
    }

    private onChange: () => void;

    validate(control: AbstractControl): { [key: string]: any } {
        if (!control.value)
            return null;

        if (this.validateEqual && control.value !== this.validateEqual.value)
            return { validateEqual: false };

        return null;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/validators/equalValidator.ts